/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 22/11/21
 */
import React, {memo, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Collapse } from 'antd';
import SectionTitle from '../SectionTitle';
import WrapperFieldType from '@/modules/audits/components/WrapperRunAudit/components/ManageAuditContent/components/WrapperFieldType';
import {useTranslation} from 'react-i18next';
import styles from './index.less';
import {useAuditData} from '@/modules/auditorAudits/hooks/useAuditData';
import HeaderCover from '@/modules/audits/components/WrapperRunAudit/components/ManageAuditContent/components/WrapperFieldType/HeaderCover';
import {CONTACT_POOLS_FIELDS} from '@/modules/auditorAudits/contants/auditorAudits';

const { Panel } = Collapse;

const SectionBox = ({section, id, isCover, countData, isContact}) => {
  const {t} = useTranslation('templates');
  const [activeKey, setActiveKey] = useState(['1']);
  const {currentAudit} = useAuditData();

  const filteredContactFields = useMemo(() => {
    if (!currentAudit?.service?.isPoolService) {
      return currentAudit?.contactFields?.filter((field) => {
        return !CONTACT_POOLS_FIELDS.includes(field?.type);
      });
    }
    else {
      return currentAudit?.contactFields;
    }
  }, [currentAudit?.contactFields, currentAudit?.service?.isPoolService]);

  if (isCover) {
    return (
      <div id={id} className="wrapper-section-panel">
        <Collapse defaultActiveKey={activeKey} bordered={false} onChange={setActiveKey} className={classNames(styles.wrapperPanel)}>
          <Panel className="wrapper-panel-audit" header={<SectionTitle status={currentAudit?.status} section={{title: 'Introduction'}} activeKey={activeKey} isCover={isCover} />} key="1" showArrow={false}>
            <HeaderCover countData={countData}/>
            {currentAudit?.coverFields?.length === 0
              ?
              <div className="w-full flex items-center justify-center min-h-8">{t('noQuestionsForThisSection')}</div>
              : currentAudit?.coverFields?.map(item => {
                return <WrapperFieldType key={item?._id} type={item?.type} question={item} data={currentAudit} isCover section={section} />;
              })}
          </Panel>
        </Collapse>
      </div>
    );
  }

  if (isContact) {
    return (
      <div id={id} className="wrapper-contact-panel">
        <Collapse defaultActiveKey={activeKey} bordered={false} onChange={setActiveKey}
          className={classNames(styles.wrapperPanel)}>
          <Panel className="wrapper-panel-audit" header={<SectionTitle section={{title: 'Contactos'}} activeKey={activeKey} isCover={true}/>}
            key="1" showArrow={false}>
            {currentAudit?.contactFields?.length === 0
              ? <div
                className="w-full flex items-center justify-center min-h-8">{t('noQuestionsForThisSection')}</div>
              : filteredContactFields?.map(item => {
                return <WrapperFieldType key={item?._id} type={item?.type} question={item} sectionId={section?._id}
                  section={section}/>;
              })}
          </Panel>
        </Collapse>
      </div>
    );
  }

  if (section?.type === 'CONTACTS') {
    return null;
  }

  return (<div id={id} className="wrapper-section-panel">
    <Collapse defaultActiveKey={activeKey} bordered={false} onChange={setActiveKey}
      className={classNames(styles.wrapperPanel)}>
      <Panel className="wrapper-panel-audit" header={<SectionTitle section={section} activeKey={activeKey}/>}
        key="1" showArrow={false}>
        {section?.questions?.length === 0
          ?
          <div className="w-full flex items-center justify-center min-h-8">{t('noQuestionsForThisSection')}</div>
          : section?.questions?.map(item => {
            return <WrapperFieldType key={item?._id} type={item?.type} question={item} sectionId={section?._id}
              section={section}/>;
          })}
      </Panel>
    </Collapse>
  </div>
  );
};

SectionBox.propTypes = {
  section: PropTypes.object,
  id: PropTypes.string,
  isCover: PropTypes.bool,
  isContact: PropTypes.bool,
  countData: PropTypes.object,
};

export default memo(SectionBox);
